import React from "react";

const LocationSection = () => {
  return (
    <section className="bg-gray-100 py-16" id="location">
      <div className="container mx-auto px-6 text-center">
        <h2 className="text-black heading-style mb-4">Explore Our Location</h2>
        <p className="subheading-style mb-8">
          Visit us at our location or explore the map below to find your way.
        </p>
        <div className="relative w-full h-96 rounded-lg overflow-hidden shadow-lg">
          {/* Embed your map iframe here */}
          <iframe
            className="absolute top-0 left-0 w-full h-full"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3679.1834266380233!2d75.86622367406571!3d22.758573126130837!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x396303ec55b2d331%3A0x395d8fcc73c4ae4d!2sQuantaRock%20Systems%20Pvt%20Ltd%20%7C%20interseller!5e0!3m2!1sen!2sin!4v1736673970913!5m2!1sen!2sin"
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Location Map"
          />
        </div>
      </div>
    </section>
  );
};

export default LocationSection;
